import { api } from 'common';

/**
 * Default configuration for a Subflow and SkillV2 block.
 */
export function getSubFlowBlockDefaultConfig(): api.FlowDefinition.SubFlowV2BlockConfig {
  return {
    flowDefinitionId: '',
    flowId: '',
    versionTarget: api.FlowDefinition.FlowVersionTarget.Published,
    arguments: [],
  };
}
